<script>
    import {links} from "svelte-routing";

</script>

<div use:links>

    <button class="btn btn-light">Sitemap generieren</button>

    <a href="/settings/config"><button class="btn btn-light">Konfiguration ändern</button></a>

</div>
